import React from 'react';
import {  Row, Col } from 'antd';

const ViewVisitorForm = ({ visitor, closeModal }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    return (
        <div className="visitor-form-container">
            <div className="visitor-details">
                <Row gutter={16}>
                    <Col span={12}>
                        <p><strong>Visitor ID:</strong> {visitor.recono}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Visitor Name:</strong> {visitor.visitorname}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Visitor Type:</strong> {visitor.visitortype}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Company Name:</strong> {visitor.companyname}</p>
                    </Col>
                    {user?.role === "SUPERADMIN" && (
                    <Col span={12}>
                    <p><strong>Sitename:</strong> {visitor.sitename}</p>
                        </Col>
                        )}
                    <Col span={12}>
                        <p><strong>Reception Number:</strong> {visitor.recono}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>licenseplate Number:</strong> {visitor.licenseplate}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Phone:</strong> {visitor.phone}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Time-in:</strong> {visitor.timein ? new Date(visitor.timein).toLocaleString() : null }</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Time-out:</strong> {visitor.timeout ? new Date(visitor.timeout).toLocaleString() : null}</p>
                    </Col>
 
                </Row>
            </div>
        </div>
    );
};

export default ViewVisitorForm;
